import api from './api';
import { Page } from '../types';

export const pagesService = {
    // Get all pages
    getAll: async (): Promise<Page[]> => {
        const response = await api.get('/pages');
        return response.data;
    },

    // Sync pages from Facebook
    sync: async (): Promise<{ message: string; count: number; pages: Page[] }> => {
        const response = await api.post('/pages/sync');
        return response.data;
    },

    // Get specific page
    getById: async (id: string): Promise<Page> => {
        const response = await api.get(`/pages/${id}`);
        return response.data;
    },

    // Delete a page
    delete: async (id: string): Promise<void> => {
        await api.delete(`/pages/${id}`);
    },
};
